import update from 'immutability-helper';
import {
  POST_CONTENT_CHANGE, POST_CATEGORY_CHANGE,
  POST_DAUM_LIKE_CATEGORY_CHANGE, POST_PASSWORD_CHANGE,
  POST_PUBLISHED_CHANGE, POST_SLOGAN_CHANGE,
  POST_TITLE_CHANGE, POST_VISIBILITY_CHANGE,
  POST_ACCEPT_COMMENT_CHANGE, POST_CCL_CHANGE,
  POST_TAG_ADD, POST_TAG_REMOVE, POST_CHANGED,
  POST_THUMBNAIL_CHANGE, DRAFT_COUNT_UPDATE,
  UPDATE_TITLE_AND_CONTENT, POST_TAG_UPDATE,
  INCREASE_UPLOAD_PROGRESS_COUNT, DECREASE_UPLOAD_PROGRESS_COUNT, POST_RECAPTCHA_VALUE_CHANGE,
  POST_SET_DRAFT_SEQUENCE, POST_TAGS_SET
} from "../constants/ActionTypes";
import {generatePassword, titleToSlogan} from "../lib/PostUtils";
import {MAX_TAG_COUNT} from "../constants/limits";

const initialState = {
  orgPost: window.Config.post,
  newPost: Object.assign({
    id: 0,
    tags: [],
    category: 0,
    published: 1,
    visibility: window.Config.blog.visibilityType,
    title: '',
    content: '',
    password: generatePassword(),
    uselessMargin: window.Config.blog.uselessMargin,
    cclCommercial: window.Config.blog.cclCommercial,
    cclDerive: window.Config.blog.cclDerive,
    recaptchaValue: '',
  }, window.Config.post),
  needCaptcha : window.appInfo.needCaptcha,
  captchaVerified : false,
  draftCount: window.Config.draftCount,
  uploadProgressCount: 0,
  draftSequence: null
};

function setChanged(changed) {
  window.postChanged = changed;
}

export default (state = initialState, action) => {

  let index = -1;
  switch(action.type) {
    case POST_CHANGED:
      setChanged(action.changed);
      return state;

    case POST_TITLE_CHANGE:
      const title = action.title.replace(/\n/g, '');
      const slogan = (state.newPost.id === 0)? titleToSlogan(title) : state.newPost.slogan;
      setChanged(true);

      return update(state, {
        newPost: {
          title: {
            $set: title
          },
          slogan: {
            $set: slogan
          }
        }
      })
    case POST_CONTENT_CHANGE:
      setChanged(true);

      return update(state, {
        newPost: {
          content: {
            $set: action.content
          }
        }
      })
    case POST_THUMBNAIL_CHANGE:
      setChanged(true);

      return update(state, {
        newPost: {
          thumbnail: {
            $set: action.thumbnail
          }
        }
      });
    case POST_CATEGORY_CHANGE:
      setChanged(true);
      return update(state, {
        newPost: {
          category: {
            $set: action.categoryId
          },
          daumLikeCategory: {
            $set: action.viewChanel
          }
        }
      })
    case POST_DAUM_LIKE_CATEGORY_CHANGE:
      return update(state, {
        newPost: {
          daumLikeCategory: {
            $set: action.daumLikeCategory
          }
        }
      })
    case POST_PASSWORD_CHANGE:
      return update(state, {
        newPost: {
          password: {
            $set: action.password
          }
        }
      })
    case POST_PUBLISHED_CHANGE:
      return update(state, {
        newPost: {
          published: {
            $set: action.published
          }
        }
      })
    case POST_SLOGAN_CHANGE:
      return update(state, {
        newPost: {
          slogan: {
            $set: action.slogan
          }
        }
      })
    case POST_VISIBILITY_CHANGE:
      return update(state, {
        newPost: {
          visibility: {
            $set: action.visibility
          },
          published: {
            $set: state.newPost.published > 1? state.newPost.published : state.newPost.id === 0? 1 : 0
          }
        }
      })
    case POST_RECAPTCHA_VALUE_CHANGE:

      let captchaVerified = (action.recaptchaValue != '')

      return update(state, {
        newPost: {
          recaptchaValue: {
            $set : action.recaptchaValue
          }
        },
        captchaVerified : {
          $set : captchaVerified
        }
      })
    case POST_ACCEPT_COMMENT_CHANGE:
      return update(state, {
        newPost: {
          acceptComment: {
            $set: action.acceptComment
          }
        }
      })
    case POST_CCL_CHANGE:
      return update(state, {
        newPost: {
          cclDerive: {
            $set: action.cclDerive
          },
          cclCommercial: {
            $set: action.cclCommercial
          }
        }
      })
    case POST_TAG_ADD:
      if (state.newPost.tags) {
        if (state.newPost.tags.length >= MAX_TAG_COUNT) {
          return state;
        }

        index = state.newPost.tags.indexOf(action.tag);
        if (index >= 0) {
          return state;
        }
      }

      setChanged(true);
      return update(state, {
        newPost: {
          tags: {
            $push: [action.tag]
          }
        }
      })
    case POST_TAG_REMOVE:
      index = state.newPost.tags.indexOf(action.tag)
      if (index < 0) {
        return state
      }

      setChanged(true);
      return update(state, {
        newPost: {
          tags: {
            $splice: [[index, 1]]
          }
        }
      });

    case POST_TAG_UPDATE:
      index = state.newPost.tags.indexOf(action.orgTag);
      if (index < 0) {
        return state;
      }

      setChanged(true);
      return update(state, {
        newPost: {
          tags: {
            [index]: {
              $set: action.tag
            }
          }
        }
      });

    case POST_TAGS_SET:
      return update(state, {
        newPost: {
          tags: {
            $set: action.tags
          }
        }
      });

    case DRAFT_COUNT_UPDATE:
      return update(state, {
        draftCount: {
          $set: action.count
        }
      });

    case UPDATE_TITLE_AND_CONTENT:
      return update(state, {
        newPost: {
          title: {
            $set: action.title
          },
          content: {
            $set: action.content
          }
        }
      });

    case INCREASE_UPLOAD_PROGRESS_COUNT:
      return update(state, {
        uploadProgressCount: {
          $set: state.uploadProgressCount + 1
        }
      });

    case DECREASE_UPLOAD_PROGRESS_COUNT:
      return update(state, {
        uploadProgressCount: {
          $set: state.uploadProgressCount > 0? state.uploadProgressCount - 1 : 0
        }
      });

    case POST_SET_DRAFT_SEQUENCE:
      return update(state, {
        draftSequence: {
          $set: action.draftSequence
        }
      });
  }
  return state
}
